import { useGetOrganisation } from 'features/organisations/hooks/useGetOrganisation';
import { useParams } from 'react-router-dom';

export function OrganisationBreadcrumb() {
  const { organisationId = '' } = useParams();
  const { organisation } = useGetOrganisation(organisationId);

  return organisation?.name ?? organisationId;
}
